import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "material-ui/styles";
import Button from '../../../../Parts/Button';
import { isEnabledUserRole } from '../../../../../utils/utils';
import { isEnabledExportExecutiveList, isEnabledSendLetter } from '../../../../../utils/planUtils';
import { isEnableFunction } from '../../../../../utils/componentUtils';
import { isEnableSendOneLetter } from '../../../../../utils/userOptionUtils';

const styles = () => ({
  buttonContainer: {
    margin: '0px 20px 30px 20px',
    color: '#FFFFFF',
  },

  buttonRow: {
    flex: 1,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    margin: '40px 20px 30px 20px',
  },

  listButton: {
    height: '48px',
    alignItems: 'center',
    width: '100%',
    boxSizing: 'border-box',
    color: '#1A65FF',
    backgroundColor: '#F2F6FF',
    border: 'none',
    '&:hover': {
      backgroundColor: '#F2F6FF',
      opacity: .6,
    }
  },

  letterButton: {
    height: '48px',
    alignItems: 'center',
    width: '100%',
    boxSizing: 'border-box',
    color: "#FFFFFF",
    backgroundColor: '#1A65FF',
    border: 'none',
    '&:hover': {
      backgroundColor: '#1A65FF',
      opacity: .6,
    }
  },

  disabledButton: {
    height: '48px',
    alignItems: 'center',
    width: '100%',
    boxSizing: 'border-box',
    color: "#181819",
    backgroundColor: '#D8DBDF',
    border: 'none',
    '&:hover': {
      backgroundColor: '#D8DBDF',
      opacity: .6,
    }
  },
});

class Footer extends React.Component {
  renderButtonsRow = () => {
    const { classes } = this.props;
    return (
      <div className={classes.buttonRow}>
        {this.renderListControlButton()}
        {this.renderSendLetterButton()}
        {this.renderCsvDownloadButton()}
      </div>
    );
  }

  renderListControlButton = () => {
    const { classes } = this.props;

    if (isEnableFunction(this.props,'toggleEditTagsDialog')) {
      return (
        <Button
          className={isEnabledUserRole(this.props.user, "executive-list", "edit-tag") ? classes.listButton : classes.disabledButton}
          handleClickButton={()=>{
            this.props.toggleDialog();
            this.props.toggleEditTagsDialog();
          }}
          text="リストに追加 / 削除"
          size="large"
          disabled={!isEnabledUserRole(this.props.user, "executive-list", "edit-tag")}
          >
      </Button>
      );
    } else {
      return null;
    }
  }

  renderCsvDownloadButton = () => {
    const { classes } = this.props;

    if ((this.props.enableExecutiveListAdvancedSearch || isEnabledExportExecutiveList(this.props.user)) && isEnableFunction(this.props, 'toggleCsvDownloadDialog')) {
      return (
        <Button
        className={isEnabledUserRole(this.props.user, "executive-list", "download-list") ? classes.letterButton : classes.disabledButton}
          handleClickButton={() =>{
            this.props.toggleDialog();
            this.props.toggleCsvDownloadDialog();
          }}
          text="CSVダウンロード"
          size="large"
          style={{ width: "100%", marginLeft: "10px" }}
          disabled={!isEnabledUserRole(this.props.user, "executive-list", "download-list")}
          >
        </Button>
      );
    } else {
      return null;
    }
  }

  renderSendLetterButton = () => {
    const { classes } = this.props;

    if (isEnabledSendLetter(this.props.user) && isEnableSendOneLetter(this.props.user) && isEnableFunction(this.props, 'goToSendLetter')) {
      return (
        <Button
          className={isEnabledUserRole(this.props.user, "executive-list", "order-letter") ? classes.letterButton : classes.disabledButton}
          handleClickButton={() =>{
            this.props.goToSendLetter();
          }}
          text="レター送付"
          size="large"
          style={{ width: "100%", marginLeft: "10px" }}
          disabled={!isEnabledUserRole(this.props.user, "executive-list", "order-letter")}
          >
        </Button>
      );
    } else {
      return null;
    }
  }

  renderCloseButton = () => {
    const { classes } = this.props;

    return (
      <div className={classes.buttonContainer}>
        <Button
          type="ghost"
          handleClickButton={this.props.toggleDialog}
          text="閉じる"
          size="large"
          style={{ width: "100%", background: '#ECEDEF' , color: '#181819' }}>
        </Button>
      </div>
    );
  }

  render () {
    return (
      <div>
        {this.renderButtonsRow()}
        {this.renderCloseButton()}
      </div>
    );
  }
}

Footer.propTypes = {
  classes: PropTypes.object.isRequired,
  user: PropTypes.object,
  enableExecutiveListAdvancedSearch: PropTypes.bool,
  toggleDialog: PropTypes.func.isRequired,
  toggleEditTagsDialog: PropTypes.oneOfType([PropTypes.func, PropTypes.oneOf([null])]),
  toggleCsvDownloadDialog: PropTypes.oneOfType([PropTypes.func, PropTypes.oneOf([null])]),
  goToSendLetter: PropTypes.oneOfType([PropTypes.func, PropTypes.oneOf([null])]),
}

PropTypes.defaultValue = {
  toggleEditTagsDialog: null,
  toggleCsvDownloadDialog: null,
  goToSendLetter: null,
}

export default withStyles(styles)(Footer);



// WEBPACK FOOTER //
// ./src/components/ExecutiveList/dialogs/ExecDetailItemDialog/sections/Footer.jsx